function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M47.6953 0H12.3047C5.51988 0 0 5.51988 0 12.3047V47.6953C0 54.4801 5.51988 60 12.3047 60H47.6953C54.4801 60 60 54.4801 60 47.6953V12.3047C60 5.51988 54.4801 0 47.6953 0ZM56.4844 47.6953C56.4844 52.5416 52.5416 56.4844 47.6953 56.4844H12.3047C7.4584 56.4844 3.51562 52.5416 3.51562 47.6953V12.3047C3.51562 7.4584 7.4584 3.51562 12.3047 3.51562H47.6953C52.5416 3.51562 56.4844 7.4584 56.4844 12.3047V47.6953Z",
  fill: "#E8388A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M46.3484 31.1719L45.5953 22.512C45.3566 19.766 43.0982 17.6953 40.3418 17.6953H22.383V14.7656C22.383 14.4425 22.6459 14.1797 22.969 14.1797H25.8987V15.3516H32.9299V9.49219H25.8987V10.6641H22.969C20.7074 10.6641 18.8674 12.504 18.8674 14.7656V17.7538C16.4809 18.1065 14.6205 20.034 14.4052 22.512L13.6521 31.1719H10.5762V34.6875H49.4243V31.1719H46.3484ZM17.181 31.1719L17.9074 22.8164C17.9871 21.9012 18.7399 21.2109 19.6586 21.2109H40.3417C41.2604 21.2109 42.0132 21.9012 42.0928 22.8164L42.8193 31.1719H17.181Z",
  fill: "#E8388A"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M31.7578 46.9922V38.2031H28.2422V46.9922H21.7969V50.5078H38.2031V46.9922H31.7578Z",
  fill: "#E8388A"
});

var SvgKeynote = function SvgKeynote(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKeynote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/keynote.632684a1.svg";
export { ForwardRef as ReactComponent };